import { ValidationResult } from '@common/validators/validation-result';

export class DocumentCentreConfig {
  public FileStoreRoot: string;
}

export class GetDocumentCentreConfigResponse {
  public Config: DocumentCentreConfig;
}

export class SaveDocumentCentreConfigResponse {
  public Success: boolean;
  public validationResult: ValidationResult;
}

export class SaveDocumentCentreConfigRequest {
  public Config: DocumentCentreConfig;
}
